import { isExpanded, setAccordionState, setExpanded } from '../utils/dom.js';

export const initMobileMenu = () => {
  const menuToggle = document.getElementById('menuToggle');
  const mobileMenu = document.getElementById('mobileMenu');

  if (!menuToggle || !mobileMenu) return;

  menuToggle.addEventListener('click', () => {
    const isOpen = isExpanded(menuToggle);
    setExpanded(menuToggle, !isOpen);
    menuToggle.setAttribute('aria-label', !isOpen ? 'Menüyü Kapat' : 'Menüyü Aç');
    mobileMenu.classList.toggle('is-open', !isOpen);
  });

  document.addEventListener('click', (event) => {
    const isClickInsideMenu = mobileMenu.contains(event.target);
    const isClickOnToggle = menuToggle.contains(event.target);
    const isOpen = isExpanded(menuToggle);

    if (!isClickInsideMenu && !isClickOnToggle && isOpen) {
      setExpanded(menuToggle, false);
      menuToggle.setAttribute('aria-label', 'Menüyü Aç');
      mobileMenu.classList.remove('is-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    const isOpen = isExpanded(menuToggle);
    if (event.key === 'Escape' && isOpen) {
      setExpanded(menuToggle, false);
      menuToggle.setAttribute('aria-label', 'Menüyü Aç');
      mobileMenu.classList.remove('is-open');
      menuToggle.focus();
    }
  });
};

export const initTabs = () => {
  const tabsGroups = document.querySelectorAll('[data-tabs]');

  tabsGroups.forEach((group) => {
    const tabItems = group.querySelectorAll('.tab-item');
    const tabContents = group.querySelectorAll('.tab-content');

    if (tabItems.length === 0 || tabContents.length === 0) return;

    const setActiveTab = (tabName) => {
      tabItems.forEach((item) => {
        item.classList.toggle('active', item.dataset.tab === tabName);
      });

      tabContents.forEach((content) => {
        content.classList.toggle('active', content.id === `content-${tabName}`);
      });
    };

    const activeItem = Array.from(tabItems).find((item) => item.classList.contains('active'));
    const initialTab = activeItem?.dataset?.tab || tabItems[0].dataset.tab;

    if (initialTab) {
      setActiveTab(initialTab);
    }

    tabItems.forEach((item) => {
      item.addEventListener('click', () => {
        if (item.dataset.tab) {
          setActiveTab(item.dataset.tab);
        }
      });
    });
  });
};

export const initAccordions = () => {
  const accordions = document.querySelectorAll('.accordion');

  accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll('.accordion-item');
    const triggers = accordion.querySelectorAll('.accordion-trigger');

    items.forEach((item) => {
      setAccordionState(item, item.classList.contains('accordion-item-active'));
    });

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.accordion-item');
        if (!item) return;

        const isActive = item.classList.contains('accordion-item-active');

        items.forEach((entry) => {
          if (entry !== item) {
            setAccordionState(entry, false);
          }
        });

        setAccordionState(item, !isActive);
      });
    });
  });
};
